module.exports = __webpack_public_path__ + "media/images/lp/lp23-cfbcb8deb6ad6442749e4fa939c1ce03.webp";